<script>
  import Button from '@components/buttons/button.svelte'
  import Tooltip from '@components/general/tooltip.svelte'
  import TriggerChevron from '@components/general/trigger-chevron.svelte'
  import { cn } from '@lib/utils'

  let { open = $bindable(false), text, disabled = false, class: className, Icon, showTriggerButton = true, iconSize = 12, iconClass = "text-gray-500", hint, ...buttonProps } = $props()

</script>

<Tooltip {hint}>
  <Button {disabled} class={cn("inline-flex items-center gap-2", className)} {...buttonProps}>
    {#if Icon}
      <Icon size={iconSize} class={iconClass} />
    {/if}
    {text}
    {#if showTriggerButton}
      <TriggerChevron {open} class={iconClass} />
    {/if}
  </Button>
</Tooltip>